<template>
    <div :class="{'card shadow my-2 bg-body rounded h-auto py-4 px-3 py-md-4 px-md-5' : !this.isModal}">
        <div v-if="!this.hasReachedMaxFailedAttempts && !!this.canConfirmPhone">
            <h5 class="text-center text-capitalize" :class="{'mt-3 mb-0' : !this.isModal}">
                Verify your identity by confirming your phone number
            </h5>
            <div :class="{'mb-3' : !this.isModal}">
                <div class="input-group mt-3">
                    <input type="text" class="form-control form-control-lg" :class="{'is-invalid' : !!this.errorMessage}"
                           @input="this.handleInput"
                           v-model = "this.phoneNumber"
                           :placeholder="this.phoneNumberProp"
                           maxlength="10"
                    >
                    <div v-if="!!this.errorMessage" class="invalid-feedback mt-2">
                        {{ this.errorMessage }}
                    </div>
                    <button class="btn btn-outline-success"
                            style="min-width: 100px;"
                            v-if="!this.isModal"
                            @click="this.doConfirmPhoneRequest"
                            type="button">Verify</button>
                </div>
                <small v-if="this.failedAttempts>0" class="position-absolute bottom-1 end-0 me-4 text-muted">Remaining attempts: {{ this.maxFailedAttempts - this.failedAttempts}}</small>
            </div>
        </div>
        <div v-else>
            <h4 class="text-center my-0" :class="{'mt-3 mb-0' : !this.isModal}">
                You have reached the maximum number of attempts. Please try again later.
            </h4>
        </div>
    </div>
</template>
<script>
export default {
    name: 'PhoneConfirmation',
    emits: ["phone-confirmed", 'phone-confirmation-failed'],
    props: {
        phoneNumberProp: {
            type: String,
            required: false,
        },
        uid: {
            type: String,
            required: true,
        },
        isModal: {
            type: Boolean,
            required: false,
            default: false,
        },
        canConfirmPhone: {
            type: Boolean,
            required: false,
            default: false,
        },
        failedAttempts: {
            type: Number,
            required: true,
            default: 0,
        },
        maxFailedAttempts: {
            type: Number,
            required: false,
            default: 3,
        },
    },
    data() {
        return {
            errorMessage: null,
            phoneNumber: null,
            phoneNumberConfirmed: false,
            locationUrl: window.location.href.split('?')[0],
        }
    },
    mounted() {
        console.log('PhoneConfirmation mounted');
    },
    methods: {
        clearPhoneNumber() {
            this.phoneNumber = null;
        },
        async doConfirmPhoneRequest() {

            if( !this.isPhoneNumberValid ) {
                this.errorMessage = 'Number must be 10 digits.';
                return;
            }

            // API request
            let requestResponse = await this.submitRequest('confirmation', {
                uid: this.uid,
                phone: this.phoneNumber,
                source: this.locationUrl
            });

            if(requestResponse) {
                console.log(requestResponse.status);
                switch(requestResponse.status) {
                    case 'success':
                        this.phoneNumberConfirmed = true;
                        // lets keep in local storage in case user comes back to the page
                        let localStorageData = JSON.parse(localStorage.getItem(`refresh-results-${this.uid}`)) ?? {};
                        let newData = {
                            phoneNumberConfirmed: !!this.phoneNumberConfirmed,
                            phoneNumber: this.phoneNumber,
                        };
                        let storeNewData = JSON.stringify({...localStorageData,...newData});
                        localStorage.setItem(`refresh-results-${this.uid}`, storeNewData);
                        this.$emit('phone-confirmed', this.phoneNumber);
                    break;

                    case 'disabled':
                        this.errorMessage = 'You have reached the maximum number of attempts. Please try again later.';
                        this.clearPhoneNumber();
                        this.$emit('phone-confirmation-failed', 3);
                    break;

                    case 'error':
                    default:
                        this.errorMessage = 'Incorrect phone number. Please try again.';
                        this.clearPhoneNumber();
                        this.$emit('phone-confirmation-failed');
                    break;
                }
            }
            else {
                this.errorMessage = 'Incorrect phone number. Please try again.';
                this.clearPhoneNumber();
                if( this.hasReachedMaxFailedAttempts ) {
                    this.$emit('phone-confirmation-failed');
                }
                return;
            }
        },
        async submitRequest(type = 'confirmation', data) {
            this.isLoading = true;

            let requestEndpoints = {
                'confirmation': '/portal/phone/confirmation',
            };

            let apiResponse = await
                axios.post(requestEndpoints[type], data)
                    .then(res => {
                        return res.data;
                    }).catch(err => {
                    // TODO -- email exception?
                    return false;
                });

            // console.log('apiResponse', apiResponse);
            return apiResponse;
        },
        handleInput(event) {
            this.phoneNumber = event.target.value.replace(/\D/g, '');
        },
    },
    computed: {
        isPhoneNumberValid() {
            return this.phoneNumber && this.phoneNumber.length === 10;
        },
        hasReachedMaxFailedAttempts() {
            return this.failedAttempts >= this.maxFailedAttempts;
        },
    },
}
</script>
